"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.assign.js");

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _react2 = require("@chakra-ui/react");

var _InputType = _interopRequireDefault(require("./InputType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FormField = _ref => {
  var {
    name,
    label,
    placeholder,
    type,
    isLoading,
    options,
    isRequired,
    bgInput,
    labelColor,
    colorScheme,
    size,
    disabled,
    style,
    isMulti = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: name
  }, _ref2 => {
    var {
      field,
      form
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_react2.FormControl, _extends({
      isInvalid: form.errors[name] && form.touched[name],
      isRequired: isRequired
    }, style), /*#__PURE__*/_react.default.createElement(_react2.FormLabel, {
      htmlFor: name,
      color: labelColor,
      fontSize: "sm",
      height: "15px"
    }, label), /*#__PURE__*/_react.default.createElement(_InputType.default, _extends({}, field, {
      id: name,
      placeholder: placeholder,
      type: type,
      isLoading: isLoading,
      form: form,
      options: options,
      bgInput: bgInput,
      colorScheme: colorScheme,
      size: size,
      disabled: disabled,
      isMulti: isMulti
    })), /*#__PURE__*/_react.default.createElement(_react2.FormErrorMessage, null, form.errors[name]));
  });
};

var _default = FormField;
exports.default = _default;